import type { FC } from "react";

import { Button } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";

import { useHeaderTranslations } from "../useHeaderTranslations";

type Props = {
  playNowLink?: string;
  burgerButton?: boolean;
  featureFlags?: {
    isCreateButtonEnabled: boolean;
  };
  loginHeader: () => void;
  createAccountHeader: () => void;
};

export const HeaderAuthButtons: FC<Props> = ({
  playNowLink,
  burgerButton,
  featureFlags,
  loginHeader,
  createAccountHeader,
}) => {
  const t = useHeaderTranslations();

  const redirectToRoom = (): void => {
    if (playNowLink) {
      window.location.href = playNowLink;
    }
  };

  if (burgerButton && featureFlags?.isCreateButtonEnabled) {
    return (
      <Button
        size="small"
        className="w-full px-3 md:px-6 h-12"
        weight="bold"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
        variant="transparent"
      >
        {t.buttons.login}
      </Button>
    );
  }

  return (
    <Flex align="center" gap={10}>
      <Button
        size="xsmall"
        md={{ size: "small" }}
        weight="bold"
        className="hidden md:flex px-3 md:px-6 h-8 md:h-12"
        variant="transparent"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
      >
        {t.buttons.login}
      </Button>

      {featureFlags?.isCreateButtonEnabled && (
        <Button
          size="xsmall"
          md={{ size: "small" }}
          weight="bold"
          className="h-8 md:h-12 px-3 md:px-6"
          onPress={() => {
            createAccountHeader();
            redirectToRoom();
          }}
        >
          {t.buttons.create}
        </Button>
      )}
    </Flex>
  );
};
